// extracted by mini-css-extract-plugin
module.exports = {"root":"Parameter_root__FYi5_","container":"Parameter_container__Py6_1","menu_inverter":"Parameter_menu_inverter__2kVLD","content":"Parameter_content__2D736"};